import { useState } from "react";

const ModalConfirmAanmelden = (props) => {

    const { activiteitNaam, activiteitDatum, taaknaam, cancelAanmelden, confirmAanmelden } = props;

    const [extraInfo, setExtraInfo] = useState("");

    const handleChange = (e) => {
        setExtraInfo(e.target.value);
    }

    const handleCancel = () => {
        cancelAanmelden();
    }

    const handleBevestig = () => {
        confirmAanmelden(extraInfo);
    }

    return (
        <div className="modalTaakAanmelden">
            <div className="modalBackground">
                <div className="modal">
                    <div className="modalContentContainer">
                        <div className="modalLogoContainer">
                            <img src="/images/BrinkruitersLogoAlpha.png" alt="" />

                        </div>

                        <div className="details">
                            <p>Meld je aan als vrijwilliger voor:</p>
                            <p className="itemTitle1">Activiteit en datum: </p>
                            <p>{activiteitNaam}</p>
                            <p>{activiteitDatum}</p>
                            <p className="itemTitle1">Vrijwilligerstaak: </p>
                            <p>{taaknaam}</p>
                            <div className="addExtraInfo">
                                <p>Voeg eventueel extra info toe, bijvoorbeeld over je beschikbaarheid op bepaalde tijdstippen:</p>
                                <textarea 
                                    name="aanmeldInfo" 
                                    id="" 
                                    cols="60" 
                                    rows="3"
                                    onChange={handleChange}
                                    
                                >

                                </textarea>

                            </div>
                            {/* <input 
                                type="text"
                                onChange={handleChange}
                                name="aanmeldInfo"
                            /> */}

                            <p className="aanmeldInfo one">Als je deze aanmelding bevestigt, verschijnt je gebruikersnaam bij deze taak als aangemeld. De contactpersoon voor deze activiteit/taak zal later de aanmelding bevestigen (zichtbaar als "Ingedeeld" bij de taak), of contact met je opnemen. </p>
                            <p className="aanmeldInfo two">
                            Je kunt later in het dashboard van deze app zien hoe laat je verwacht wordt. Eventuele extra info wordt daar ook weergegeven.
                            </p>
                        </div>
                        <div className="buttonContainer">
                            <button className="button" onClick={handleCancel}>Cancel</button>
                            <button className="button bevestig" onClick={handleBevestig}>Bevestig</button>

                        </div>

                    </div>

                </div>

            </div>        
        </div>
    );
}

export default ModalConfirmAanmelden;